import 'rxjs/add/operator/map';
import { Router} from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../services/snackbar.service';
import { FormGroup, FormControl,Validators } from '@angular/forms';

@Component({
  selector: 'app-edit-exercise',
  templateUrl: './edit-exercise.component.html',
  styleUrls: ['./edit-exercise.component.css']
})
export class EditExerciseComponent implements OnInit {


formdata;
exerciseId;
exerciseName;
timeDuration;
submitted;
formdetail;
invalid:boolean  = false;

apiBaseUrl : string = environment.url;

constructor(private http: HttpClient, private router: Router,private route:ActivatedRoute,private snackbar:SnackbarService) { }

    //constructor(private http: Http, private router: Router) { }

  ngOnInit() {
this.exerciseId = this.route.snapshot.params.id;

 this.formdata = new FormGroup({
      exerciseName: new FormControl("",[Validators.required]),
      timeDuration: new FormControl("",[Validators.required])     
    });

this.http.post(this.apiBaseUrl+'v1/getExerciseAdminForEdit',{id:this.exerciseId}).subscribe((data : any) => {
     if(data.status == 200){
     	console.log(data.data[0])
this.formdata.setValue({
'exerciseName' : data.data[0].exerciseName,
'timeDuration' : data.data[0].timeDuration
})

}
})

}

  get f() { return this.formdata.controls; }







 editExerciseByAdmin(data) {
      this.submitted = true;         
        if (this.formdata.invalid) {
            return;
        }
         this.formdetail = {
             'exerciseId':this.exerciseId,
             'exerciseName':data.exerciseName,
             'timeDuration':data.timeDuration,
             //'thumbnail':this.thumbnail
         }       
    
    
    this.http.post(this.apiBaseUrl+'v1/editExerciseAdmin',this.formdetail).subscribe((data : any) => {
     if(data.status == 200){ 
      this.snackbar.successSnackBar("Exercise updated successfully.",'');

       this.router.navigate(['/exercises']);
     
   }     
         else
         {
          
          this.invalid = true;
  
         }

     })

     }

     thumbnail : any
     thumbnailSrc : any
     invalidThumbnail = false
     @ViewChild('thumbnail') thumbnailElement :ElementRef
     uploadThumbnail(event) {

      const fileName: any = event.target.files[0];
      this.thumbnail = event.target.files[0];  
      const idxDot = event.target.files[0].name.lastIndexOf(".") + 1;
      const extFile = event.target.files[0].name.substr(idxDot, event.target.files[0].name.length).toLowerCase();
      const filesize = fileName.size / 1024
      if (filesize > 100) {
        alert("Please provide video with less then 100 Kb.");
        return;
      }
  
      if (extFile == "png") {
        const reader = new FileReader();
        reader.onload = e => this.thumbnailSrc = reader.result;
        reader.readAsDataURL(fileName);
        this.invalidThumbnail = false;
      } else {
        this.thumbnailElement.nativeElement.value=''
        this.invalidThumbnail = true;
      }
    }

numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  
}
